import { apiRequest } from '../services/apiClient';

const BASE = '/gateway/api/ticket/tags';

const unwrapList = (response) => {
  const payload = response?.data ?? response;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const ticketTagService = {
  /** Active tags for ticket assignment UI (authenticated, tenant-scoped). */
  async listActive() {
    const response = await apiRequest(BASE, { method: 'GET' });
    return unwrapList(response);
  },

  /** Admin tag master list. */
  async listForAdmin(includeInactive = true) {
    const params = new URLSearchParams();
    if (includeInactive) params.set('includeInactive', 'true');
    const qs = params.toString();
    const response = await apiRequest(`${BASE}/manage${qs ? `?${qs}` : ''}`, { method: 'GET' });
    return unwrapList(response);
  },

  async create(payload) {
    const response = await apiRequest(BASE, { method: 'POST', body: payload });
    return response?.data ?? response;
  },

  async update(tagId, payload) {
    const response = await apiRequest(`${BASE}/${tagId}`, { method: 'PUT', body: payload });
    return response?.data ?? response;
  },

  async updateStatus(tagId, active) {
    const response = await apiRequest(`${BASE}/${tagId}/status`, {
      method: 'POST',
      body: { active }
    });
    return response?.data ?? response;
  },

  async remove(tagId) {
    const response = await apiRequest(`${BASE}/${tagId}`, { method: 'DELETE' });
    return response?.data ?? response;
  }
};

export default ticketTagService;
